import { render } from "./pokemonMoves.vue?vue&type=template&id=372e9608&scoped=true&ts=true"
import script from "./pokemonMoves.vue?vue&type=script&lang=ts"
export * from "./pokemonMoves.vue?vue&type=script&lang=ts"

import "./pokemonMoves.vue?vue&type=style&index=0&id=372e9608&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/kamigame-game-tool/kamigame-game-tool/packages/legends-arceus/move-search/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-372e9608"]])

export default __exports__